module.exports = __webpack_public_path__ + "img/South-Africa.445467bd.png";